import _ from "lodash";

class PlaylistFirstVisibleElement {
	static NextAfterNowPlaying = { title: "Next track following Now Playing", value: 0 };
	static NowPlaying = { title: "Currently Playing Track", value: 1 };

	static getArray() {
		return _.keys(this).map(l => this[l]);
	}
}

export default PlaylistFirstVisibleElement;